var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.f1cc287de04c241f3fd143104813a5ff.svg#k';
                    var viewUrl = 'sprites.f1cc287de04c241f3fd143104813a5ff.svg#view-k';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 18 18',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };